<style scoped lang="scss">
@media
screen and (max-width: 375px) and (min-width: 374px),
screen and (max-width: 414px) and (min-width: 413px),
screen and (max-width: 640px) and (min-width: 600px),
screen and (min-width: 300px) and (max-width:400px)
{
  p{
    font-size: 14px!important;
  }
}
  .wrap-tec{
    .container{
      width:1000px;
    }
    .rec{
      font-size: 20px;
      color: #014492;
      background: #EFF5FF;
      border-radius: 4px;
      width: 280px;
      margin:0 auto 10px;
      text-align: center;
      padding:20px 0;
    }
    .service-lists{
      display: flex;
      justify-content: space-between;
      margin:20px 0;
      li{
        display: flex;
        align-items: center;
        &:before{
          content: '';
          width:8px;
          height: 8px;
          background: #333;
          border-radius: 50%;
          display: block;
          margin-right: 10px;
        }
      }
    }
    h4{
      font-size: 18px;
      text-align: center;
      margin:20px 0;
    }
  }
  p{
    font-size: 16px;
    line-height: 2;
  }
@media
screen and (max-width: 375px) and (min-width: 374px),
screen and (max-width: 414px) and (min-width: 413px),
screen and (max-width: 640px) and (min-width: 600px),
screen and (min-width: 300px) and (max-width:400px)
{
  .con1{
    display: none!important;
  }
  .cons{
    display: block!important;
  }
  .gene_img img {
    width: 100%;
  }
}
.cons{
  display: none;
}
</style>
<style scoped>
@import url("../../assets/sanger.css");
</style>
<template>
  <div class="wrap wrap-tec">
    <div class="banner">
      <img src="@/assets/img/产品及服务/常规分子项目/banner6.jpg" class="img-fluid">
      <div class="info">
<!--        <div class="container tc">-->
<!--          <h1>Real-time Quantitative qPCR 检测技术服务</h1>-->
<!--          <h2 class="mt10">Real-time Quantitative qPCR detection technology service</h2>-->
<!--        </div>-->
      </div>
    </div>
    <div class="breads container" style="overflow:auto;line-height: 48px;padding-left: 10px;margin-top: 20px;">
      <bread></bread>
    </div>
    <section class="container">
      <p>本公司承接利用Real-time Quantitative PCR（qPCR）法进行课题研究的技术服务，提供从引物设计合成开始，至qPCR反应检测的一条龙技
        术服务！</p>
      <div class="c-title">实验方案<small>Experimental program</small></div>
      <div class="tc"><img src="@/assets/images/qpcr_1.png"></div>
    </section>
    <section class="container">
      <div class="c-title">检测流程<small>Service Process</small></div>
      <div class="con">
        <div class="rec">相对定量PCR服务</div>
        <ul class="service-lists">
          <li>mRNA荧光定量PCR</li>
          <li>miRNA荧光定量PCR</li>
          <li>lncRNA荧光定量PCR  </li>
          <li>circRNA荧光定量PCR</li>
        </ul>
        <h4>服务内容</h4>
        <div class="con1"><img src="@/assets/images/qpcr_2.png" class="mt30"></div>
        <div class="gene_img cons" style="width: fit-content;"><img src="@/assets/images/qpcr_2.png" class="mt30"></div>
        <h4>结果</h4>
        <div class="tc mt20"><img src="@/assets/images/qpcr_3.png"></div>
        <!-- <h4>应用案例一</h4>
        <p class="tc">小鼠前成骨细胞在不同材质培养膜上进行培养时，对成骨功能相关基因ALP，Col-I，Runx-2，BMP-2和OCN进行qPCR试验，根据试验结果对基因表达水平进行表达差异分析。</p>
        <div class="tc mt20"><img src="@/assets/images/qpcr_4.png"></div>
        <p class="fz12 text-gray9 tc">成骨相关基因的qPCR结果分析图</p>
        <h4>应用案例二</h4>
        <p class="tc">对5个可能存在差异表达的基因miR-1, miR-124a, miR-133a, miR-134pri, miR-206进行qPCR检测。结果显示其中的3个miRNA预测的结果相同，证实了miRNA在针对癌症的抗性中起到了一定的作用。
        </p>
        <div class="tc mt20"><img src="@/assets/images/qpcr_5.png"></div>
        <p class="fz12 text-gray9 tc">成骨相关基因的qPCR结果分析图</p> -->
        <div class="rec">绝对定量PCR服务</div>
        <p class="tc mt20">绝对定量PCR首先必须构建与检测样品目的基因具有相同序列的标准品。使用已知浓度的标准品制作标准曲线后，利用标准曲线对未知浓度的
          检测样品进行绝对量（起始拷贝数）分析。</p>
        <div class="tc mt20"><img src="@/assets/images/qpcr_6.png"></div>
        <h4>结果</h4>
        <div class="tc mt20"><img src="@/assets/images/qpcr_7.png"></div>
        <!-- <h4>应用案例三</h4>
        <p>分别在一片玉米地和邻近的河岸土地收集相同3个时间点的土壤样品，通过对反硝化菌群鉴定基因nirS, nirSp, nirK和nosZ进行绝对定量来研究
          土壤反硝化菌群的丰度。结果分析表明nirS, nirSp, nirK和nosZ基因丰度在不同生态环境，不同时间点都存在变化。尤其是nirK基因在7月这一
          时间点上的河岸和农耕土壤存在明显差异；nirS基因在6月河岸和农耕土壤存也存在明显差异。</p>
        <div class="tc mt20"><img src="@/assets/images/qpcr_8.png"></div> -->
      </div>
    </section>
    <qk-consult type="Virus"/>
  </div>
</template>
<script>
import bread from "@/components/bread"
export default {
  components: {
    bread,
  },
  data () {
    return {

    }
  },
  methods: {

  }
}
</script>



// WEBPACK FOOTER //
// src/views/tec/qPCR.vue